import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class GoalsTableStatusSelectorComponent extends Component {
  @service betaToggle;

  get goal() {
    return this.args.goal;
  }

  @action
  handleStatusChange(goal, e) {
    goal.active = e;
    goal.save();
  }
}
